import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductsService } from '../../../../../../services/products/products.service';
import { ToastrService } from 'ngx-toastr';
import { Product } from '../../../../../../models/Product';

@Component({
  selector: 'app-valeur-stock',
  templateUrl: './valeur-stock.component.html',
  styleUrls: ['./valeur-stock.component.scss']
})
export class ValeurStockComponent implements OnInit {
  productId!: number;
  productData: any = {};
  valeurUnitaire: number = 0;

  constructor(
    private route: ActivatedRoute,
    private productsService: ProductsService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
    this.getProduct();
  }

  getProduct(): void {
    this.productsService.getDetailsProduct(this.productId).subscribe({
      next: (response: Product) => {
        this.productData = response;
        // Convertir en nombre pour s'assurer que c'est un type numérique
        this.valeurUnitaire = parseFloat(String(this.productData.valeur_unitaire || 0)) || 0;
      },
      error: (err) => {
        console.error('Erreur lors du chargement du produit:', err);
        this.toastr.error('Erreur lors du chargement du produit');
      }
    });
  }

  formatPrice(price: number | string | null | undefined): string {
    // Convertir en nombre si ce n'est pas déjà le cas
    const numPrice = typeof price === 'number' ? price : parseFloat(String(price || 0));
    
    // Vérifier si la conversion a réussi
    if (isNaN(numPrice)) {
      return '0,000';
    }
    
    return numPrice.toFixed(3).replace('.', ',');
  }
}
